import Vue from 'vue';
import { MutationTree } from 'vuex';

// Store types
import { RootState, SpacesMutation, SpacesConfigData, ToolSpace } from '@/store/store.types';

/**
 *  Holding all the mutations of the spaces.
 */
export const Mutations: MutationTree<RootState> = {

    /**
     *  Used to store the data that is needed to configure a space, including
     *  the floors, insulation levels and installation locations.
     */
    [SpacesMutation.CONFIG_DATA](state: RootState, data: SpacesConfigData): void {

        state.spaces.configData = data;

    },

    /**
     *  Used to add a new space.
     */
    [SpacesMutation.ADD](state: RootState, space: { [toolSpaceId: string]: ToolSpace; }): void {

        state.spaces.added = {
            ...state.spaces.added,
            ...space,
        };

    },

    /**
     *
     *  Used to toggle the open state of a space.
     *
     *  (i) Also closes other spaces if opened
     *
     */
    [SpacesMutation.TOGGLE](state: RootState, toolSpaceId: string): void {

        const space: ToolSpace = state.spaces.added[toolSpaceId];
        const open: boolean = space.open = !space.open;

        if (!open) {

            return;

        }

        for (const [ id, space ] of Object.entries(state.spaces.added)) {

            if (id === toolSpaceId) {

                continue;

            }

            space.open = false;

        }

    },

    /**
     *  Used to reset the system selection of a space.
     */
    [SpacesMutation.RESET_SYSTEM_SELECTION](state: RootState, toolSpaceId: string): void {

        Vue.set<null>(state.spaces.added[toolSpaceId].data, 'system', null);
        Vue.set<null>(state.spaces.added[toolSpaceId].data, 'indoor_unit', null);
        Vue.set<null>(state.spaces.added[toolSpaceId].data, 'color', null);

    },

    /**
     *  Used to remove a space.
     */
    [SpacesMutation.REMOVE](state: RootState, toolSpaceId: string): void {

        Vue.delete(state.spaces.added, toolSpaceId);

    },

    /**
     *  Used to update the overall validity of the spaces.
     */
    [SpacesMutation.VALIDITY](state: RootState, valid: boolean): void {

        state.spaces.valid = valid;

    },

};
